module.exports = __webpack_public_path__ + "static/media/中3学年模擬店.0f1187f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/store/中3学年模擬店.png
// module id = 338
// module chunks = 10